import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postPaymentCaseDocument } from 'services/PaymentsService'

export const useUploadPaymentCaseDocumentMutation = () => {
  return useMutation({
    mutationFn: postPaymentCaseDocument,
    onError: (error, data) => {
      logSentryError('Error: useUploadPaymentCaseDocumentMutation', error, data)
    },
  })
}
